/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（日曜日）
 * @export
 * @interface EnableOrderdaySun
 */
export interface EnableOrderdaySun {
}

/**
 * Check if a given object implements the EnableOrderdaySun interface.
 */
export function instanceOfEnableOrderdaySun(value: object): value is EnableOrderdaySun {
    return true;
}

export function EnableOrderdaySunFromJSON(json: any): EnableOrderdaySun {
    return EnableOrderdaySunFromJSONTyped(json, false);
}

export function EnableOrderdaySunFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdaySun {
    return json;
}

export function EnableOrderdaySunToJSON(json: any): EnableOrderdaySun {
    return EnableOrderdaySunToJSONTyped(json, false);
}

export function EnableOrderdaySunToJSONTyped(value?: EnableOrderdaySun | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

